<div class="d-flex align-items-center justify-content-between loginheader">

  <div class="py-2 d-flex align-items-center">
    <!--<a href="https://testmssidcweb.mahaitgov.in/"><img alt="MSSIDC Logo" class="MSSIDC-logo" src="assets/Images/MSSIDC_logo.png"></a>-->
    <a href="https://mssidc.maharashtra.gov.in/"><img alt="MSSIDC Logo" class="MSSIDC-logo" src="assets/Images/MSSIDC_logo.png"></a>

    <div class="logoText ps-3">
      <p class="header-h1">Maharashtra Small Scale Industries Development Corporation Ltd.</p>

      <p class="header-h2">A Government Of Maharashtra Undertaking <small>CIN No. U74999MH1962SGC012501</small></p>
    </div>
  </div>

  <div class="d-flex"><a href="https://www.maharashtra.gov.in/" target="_blank" data-bs-toggle="modal" data-bs-target="#gotowebsite"><img alt="" class="maha-logo" src="assets/Images/Maharashtra-Gov-Logo.png"></a> <a href="https://www.india.gov.in/" target="_blank" data-bs-toggle="modal" data-bs-target="#gotowebsite"><img alt="" class="emblem-logo" src="assets/Images/national_emblem_white.svg"></a></div>


</div>



<section>
  <div class="container-fluid d-flex align-items-center justify-content-center full-height">
    <div class="row w-100">
      <div class="col-md-5 mob-view  d-flex align-items-center justify-content-center">
        <div class="text-center">
          <img src="assets/Images/RAMP_LOGO_no_bg.png" class="img-fluid ramp-logo" alt="RAMP Logo" />
          <h1 class="ramp-head">Raising & Accelerating MSME Performance (RAMP)</h1>
          <!-- <h1 class="ramp-head" style="font-size: 70px;">Test Portal </h1> -->
        </div>
      </div>
      <div class="col-md-7 col-sm-12 mob-view-margin d-flex align-items-center justify-content-center">
        <div class="text-center">
          <form [formGroup]="form" (keydown)="onKeyPress($event, form)">
       <mat-card class="example-card" appearance="outlined">
    <mat-card-content>
     <a routerLink="/registeruseras" class="btn btn-danger btn-sm w-100 py-2 fs-6">New to RAMP? Register here</a>
 <mat-card-header>
             <mat-card-title class="fs-6">Already registered? Log in as</mat-card-title>
   </mat-card-header>
                <div class="col-md-12">
          <mat-radio-group formControlName="signinas" aria-label="Select an option" (change)="resetForm()">
 <mat-radio-button value="MSME" class="btn btn-warning w-100 p-0 btn-sm">MSME</mat-radio-button>
          <mat-radio-button value="IA">IA</mat-radio-button>
         <mat-radio-button value="MSSIDC">MSSIDC</mat-radio-button>
     <mat-radio-button value="DIC">DIC</mat-radio-button>
      </mat-radio-group>
               <div *ngIf="f['signinas'].touched && f['signinas'].invalid" class="alert alert-danger required">
      <div *ngIf="f['signinas'].errors?.['required']">
       Select one of the above
       </div>
             </div>
     </div>

      <div class="col-md-12">
    <mat-form-field appearance="outline" class="example-full-width">
         <mat-label>USERNAME</mat-label>
         <input type="text" matInput autocomplete="off" formControlName="username"
       id="txtUsername" placeholder="Username">
          <div *ngIf="f['username'].touched && f['username'].invalid" class="alert alert-danger required">
    <div *ngIf="f['username'].errors && f['username'].errors['required']">
     <mat-error>Username is required</mat-error>
          </div>
       <div *ngIf="f['username'].errors && f['username'].errors['minlength']">
       <mat-error><strong>Minimum length should be 3 characters</strong></mat-error>
     </div>
          </div>
        </mat-form-field>
         </div>
       <div class="col-md-12">
          <mat-form-field appearance="outline" class="col-md-12">
        <mat-label>PASSWORD</mat-label>
      <input [type]="isPasswordVisible ? 'text' : 'password'"
       matInput
      autocomplete="off"
      formControlName="password"
       id="txtPassword"
            placeholder="Password" />
      <i class="fa"
  [ngClass]="isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'"
     style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"
            (click)="togglePasswordVisibility()"></i>
             <div *ngIf="f['password'].touched && f['password'].invalid" class="alert alert-danger required">
        <div *ngIf="f['password'].errors && f['password'].errors['required']">
    <mat-error>Password is required</mat-error>
       </div>
   <div *ngIf="f['password'].errors && f['password'].errors['minlength']">
       <mat-error><strong>Minimum length should be 8 characters</strong></mat-error>
    </div>
               </div>
      </mat-form-field>
          </div>


   <div class="col-md-12 cptcha-brd p-2">
        <label for="captcha">Please enter the text below:</label>
  <div class=" captcha-container">
    <canvas id="captchaCanvas" width="160" height="60"></canvas>
     <input type="text" placeholder="Enter CAPTCHA" formControlName="captcha" class="form-control pull-left" maxlength="6" (keypress)="preventSpecialChars($event)" />
      <button #submitBtn (click)="generateCaptcha()" class="btn btn-outline-secondary mt-mob" title="Refresh Captcha"><i class="bi bi-arrow-repeat fs-6"></i></button>
 </div>
         <p *ngIf="captchaError" style="color: red; text-align:center;padding-left:20px">Invalid CAPTCHA!</p>
        </div>

       <div class="col-md-12 mt-2">
      <button id="btnlogin" (click)="mainLogin()" class="btn btn-success btn-sm me-2" type="submit" [disabled]="form.invalid || isLocked">Login</button>
     <a routerLink="/forgotpassword" class="text-muted small ms-auto">Forgot Password?</a>
        </div>






             <div class="row">
              <div class="col-md-6 text-start mt-2"> <a routerLink="/EOI"  class="manual-link" style="font-size: 18px; color: #cd1f26 !important; font-weight: bold;"><b>EOI Form</b></a></div>
              <div class="col-md-6 text-start mt-2"> <a routerLink="/eoiexhibition"  class="manual-link" style="font-size: 18px; color: #cd1f26 !important; font-weight: bold;"><b>EOI Exhibition</b></a></div> 

               
    <!-- <div class="col-md-4 text-start mt-2"> </div> -->
    </div>
        <div class="row">
              <div class="col-md-12 text-end mt-2"> <a (click)="openIAUserManual()" class="manual-link"><b>IA User Manual</b></a><br /><a (click)="openMSMEUserManual()" class="manual-link"><b>MSME User Manual</b></a></div>




    </div>



    <div class="col-md-12">
   <!-- Timer Display -->
       <p *ngIf="isLocked" class="text-danger mt-2">
       Too many failed attempts. Try again in <strong>{{ remainingTime }}</strong> seconds.
     </p>
      </div>
              </mat-card-content>
   </mat-card>
     </form>
 </div>
      </div>
    </div>

  </div>
</section>
<footer class="login-footer">
  <div class="container">
    <div class="row">

      <div class="col-sm-9">
        <div class="copyright">Copyright © 2024. All rights reserved to<span> Maharashtra Small Scale Industries Development Corporation Ltd</span></div>
      </div>
      <div class="col-sm-3">
        <div class="maintain">Designed by <a href="https://mahait.org/" target="_blank">MAHAIT</a></div>
      </div>

    </div>
  </div>
</footer>
